import {css} from 'styled-components';
import * as vars from "css/vars";

const Icons = css`

  .lock-icon {
    display: inline-block;
    width: 17.436px;
    height: 21px;
  }
`;

export default Icons;